import styled from 'styled-components';
import {
  Button,
  Form,
  Input,
  Select,
  message,
  Radio,
  Spin,
  InputNumber, Upload,
} from 'antd';
import { useSelector } from 'react-redux';
import { currentUser } from '../../../features/user/userSlice';
import { useEffect, useState } from 'react';
import {companySetLogo, editMfInfo, getMfInfo, UploadAvatar} from '../../../api/User';
import { useTranslation } from 'react-i18next';
import { CustomInput, CustomInputTextarea } from '../../../components/CustomForm';
import {t} from "i18next";
import {DIDCard} from "./components/DIDCard";
import {useMutation} from "react-query";
import {avatarUpload} from "../../../api/files";
import uploadIcon from "../../../assets/images/icons/upload-avatar@2x.png";
const { Option } = Select;

const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 6,
    },
    sm: {
      span: 4,
    },
    md: {
      span: 2,
    },
    lg: {
      span: 2,
    },
    xl: {
      span: 2,
    },
    xxl: {
      span: 2,
    },
  },
  // wrapperCol: {
  //   xs: {
  //     span: 24,
  //   },
  //   sm: {
  //     span: 18,
  //   },
  //   md: {
  //     span: 16,
  //   },
  // },
};

const PersonalContainer = styled.div`
  margin: 20px;
  .avatar {
    .ant-form-item-label {
      align-self: center;
    }
  }
`;

const AvatarWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 1024px) {
    flex-direction: column;
    >div {
      margin-top: 30px;
    }
  }
`

const UploadContent = styled.div`
  width: 108px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  > img {
    width: 100%;
  }
  &:before,
  &:after {
    content: ' ';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 300ms;
  }
  &:before {
    background-color: rgba(0, 0, 0, .8);
  }
  &:after {
    background-image: url(${uploadIcon});
    background-size: 35px;
    background-repeat: no-repeat;
    background-position: center;
  }
  &:hover:before,
  &:hover:after {
    opacity: 1;
  }
`

const beforeUpload = (file) => {
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }

  return isLt2M;
  // return false;
};

// const prefixSelector = (
//   <Form.Item name="prefix" initialValue={'86'} noStyle>
//     <Select
//       style={{
//         width: 70,
//       }}
//     >
//       <Option value="86">+86</Option>
//       <Option value="87">+87</Option>
//     </Select>
//   </Form.Item>
// );

const Personal = () => {
  // const [FormData, setFormData] = useState({});
  // const _user = useSelector(currentUser);
  // const email = localStorage.getItem('email') || null;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [pageLoading, setPageLoading] = useState(false);
  const [reciveData, setReciveData] = useState({});
  const [avatar, setAvatar] = useState()
  const [avatarId, setAvatarId] = useState()
  const _USER = useSelector(currentUser);

  const {data: avatarData, mutate: avatarMutate} = useMutation((file) => {
    const formData = new FormData();
    formData.append('image', file);
    return avatarUpload(formData)
  })

  const updateAvatar = useMutation(() => {
    const formData = new FormData();
    formData.append('logo_file_id', avatarId);
    return companySetLogo(formData)
  })

  // getMfInfo

  const getUerInfo = async () => {
    setPageLoading(true);
    try {
      const { code, data } = await getMfInfo();
      if (code === '10000') {
        setReciveData(data);
        setAvatar(data.avatar);
      }
    } catch (error) {
      setPageLoading(false);
    }
    setPageLoading(false);
  };

  const onFinish = async (values) => {
    // setFormData(values);
    try {
      const { code } = await editMfInfo(values);
      if (avatarId) await updateAvatar.mutateAsync()
      if (code === '10000') {
        message.success(t('user_center.PersonalProfile.message.success'));
        onReset();
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const onReset = () => {
    form.resetFields();
    setReciveData({});
    getUerInfo();
  };

  const onFill = () => {
    form.setFieldsValue({ ...reciveData, ...reciveData.company });
  };

  const onFinishFailed = (errorInfo) => {
    message.error('validateField');
  };

  useEffect(() => {
    getUerInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (reciveData) {
      onFill();
    }
  }, [reciveData]);

  const handleUpload = (file) => {
    if (beforeUpload(file)) {
      avatarMutate(file)
    }
    return false
  }

  useEffect(() => {
    if (avatarData) {
      const { code, data } = avatarData;
      if (code === '10000') {
        form.setFieldsValue('avatar_file_id', data.file_id)
        setAvatar(data.file_url)
        setAvatarId(data.file_id)
      }
    }
  }, [avatarData])

  return (
    <Spin spinning={pageLoading}>
      <PersonalContainer>
        <Form
          labelAlign="left"
          requiredMark={false}
          form={form}
          {...formItemLayout}
          layout="horizontal"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="mf-info"
          labelCol={{
            sm: {span: 5},
            md: {span: 5},
            lg: {span: 4},
            xl: {span: 3},
            xxl: {span: 2},
          }}
        >
          <p
            style={{
              marginBottom: '20px',
              fontSize: '12px',
              color: '#4B555E',
            }}
          >
            {t('user_center.CompanyInfo.Project')}
          </p>
          <Form.Item
              className='avatar'
              label={
                _USER.user.type === 0 ?
                    t('user_center.PersonalProfile.Avatar') :
                    t('user_center.PersonalProfile.Logo')
              }
              wrapperCol={{
                span: 12,
              }}
          >
            <AvatarWrap>
              <Upload
                  accept='image/jpeg, image/png'
                  beforeUpload={handleUpload}
                  showUploadList={false}
                  multiple={false}
                  listType='picture'
              >
                <UploadContent>
                  {
                    avatar && (
                        <img src={avatar} alt=""/>
                    )
                  }
                </UploadContent>
              </Upload>
            </AvatarWrap>
          </Form.Item>
          <Form.Item
            label={t('user_center.CompanyInfo.Email')}
            name={'email'}
            wrapperCol={{
              span: 12,
            }}
          >
            <Input className="personal-input" disabled />
          </Form.Item>
          <Form.Item
            label={t('user_center.CompanyInfo.Name')}
            name={'name'}
            wrapperCol={{
              span: 12,
            }}
          >
            <Input className="personal-input" disabled />
          </Form.Item>
          <Form.Item
            label={t('user_center.CompanyInfo.Home')}
            name={'official_site'}
            wrapperCol={{
              span: 12,
            }}
          >
            <CustomInput/>
          </Form.Item>
          <Form.Item
            label={t('user_center.CompanyInfo.Introduction')}
            name={'description'}
            wrapperCol={{
              span: 12,
            }}
          >
            <CustomInputTextarea
              rows={4}
            />
          </Form.Item>
          <p
            style={{
              // paddingLeft: '5px',
              marginBottom: '20px',
              fontSize: '12px',
              color: '#4B555E',
            }}
          >
            {t('user_center.CompanyInfo.Contact person')}
          </p>
          <Form.Item
            label={t('user_center.CompanyInfo.Real Name')}
            name={'contact_name'}
            wrapperCol={{
              span: 12,
            }}
          >
            <CustomInput className="personal-input" />
          </Form.Item>
          <Form.Item
            label={t('user_center.CompanyInfo.Phone')}
            name={'contact_mobile'}
            wrapperCol={{
              span: 12,
            }}
            
            rules={[
              {
                required: true,
                message: 'Please input your phone number!',
              },
              {
                type: 'phone',
                message: 'The input is not valid phone number!',
              },
            ]}
          >
            <CustomInput
              className="personal-input"
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
          <Form.Item
            label={t('user_center.CompanyInfo.Email')}
            name={'contact_email'}
            wrapperCol={{
              span: 12,
            }}
          >
            <CustomInput
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
          {/* <Form.Item
            label="详细地址"
            name={'address'}
            wrapperCol={{
              span: 24,
            }}
          >
            <TextArea
              rows={4}
              style={{
                borderRadius: '4px',
              }}
            />
          </Form.Item> */}
          <Form.Item
            wrapperCol={{
              xs: {
                offset: 6,
              },
              sm: {
                offset: 5,
              },
              md: {
                offset: 5,
              },
              lg: {
                offset: 4,
              },
              xl: {
                offset: 3,
              },
              xxl: {
                offset: 2,
              },
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: '#18EAC4',
                color: '#000000',
                borderColor: '#18EAC4',
              }}
            >
              {t('user_center.CompanyInfo.submit')}
            </Button>
            
          </Form.Item>
        </Form>
      </PersonalContainer>
    </Spin>
  );
};

export default Personal;
